// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   TextField,
//   Snackbar,
//   Alert,
//   Select,
//   Skeleton,
//   InputAdornment,
// } from "@mui/material";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import SearchIcon from "@mui/icons-material/Search";
// import { FiChevronUp, FiChevronDown } from "react-icons/fi";
// import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
// import {
//   fetchOTtimes,
//   assignOT,
//   fetchOTjobAttendance,
// } from "../actions/OTAction";
// import { fetchLocations, fetchJobs } from "../actions/AssignAction";
// import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
// import { useLocation } from "react-router-dom";
// import { fetchSundayData } from "../actions/OTAction";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import { maxWidth } from "@mui/system";

// const Dropdown = ({ label, value, onChange, options, loading }) => (
//   <FormControl fullWidth>
//     <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//       {label}
//     </InputLabel>
//     <Select
//       value={value}
//       onChange={onChange}
//       label={label}
//       sx={{
//         fontSize: { xs: "0.85rem", sm: "1rem" },
//         borderRadius: "20px",
//         backgroundColor: "#F0F4F8",
//         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//         "& .MuiSelect-icon": {
//           color: "#154C79",
//         },
//         "& .MuiOutlinedInput-notchedOutline": {
//           borderColor: "#154C79",
//         },
//       }}
//       MenuProps={{
//         PaperProps: {
//           sx: {
//             maxHeight: 200,
//             overflowY: "auto",
//           },
//         },
//       }}
//     >
//       {loading ? (
//         <MenuItem value="">Loading...</MenuItem>
//       ) : options.length ? (
//         options.map((option, index) => (
//           <MenuItem
//             key={index}
//             value={option.value}
//             sx={{
//               whiteSpace: "normal",
//               wordWrap: "break-word",
//               padding: "7px 16px",
//               fontWeight: "400",
//               fontSize: "14px",
//               lineHeight: "1.5",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 0, 0, 0.08)",
//               },
//               "&.Mui-selected": {
//                 backgroundColor: "rgba(0, 0, 0, 0.12)",
//               },
//             }}
//           >
//             {option.label}
//           </MenuItem>
//         ))
//       ) : (
//         <MenuItem value="">No options available</MenuItem>
//       )}
//     </Select>
//   </FormControl>
// );

// const HolidayOT = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};

//   // Redux state selectors
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.otjobAttendance
//   );
//   const { timeSlots, loading: timeSlotLoading } = useSelector(
//     (state) => state.timeSlots || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: otAssignLoading, error } = useSelector(
//     (state) => state.assignOTpost || {}
//   );
//   const { sundayData, loading: sundayDataLoading } = useSelector(
//     (state) => state.sundayData
//   );

//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   // Local state
//   const [selectedTimes, setSelectedTimes] = useState("");
//   const [selectedTimeId, setSelectedTimeId] = useState("");
//   const [selectedType, setSelectedType] = useState("SND");
//   const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
//   const [selectedAttendanceSND, setSelectedAttendanceSND] = useState({});
//   const [selectedJob, setSelectedJob] = useState("");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [selectedLocation, setSelectedLocation] = useState(role);
//   const [showDropdown, setShowDropdown] = useState(null);
//   const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");

//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [openDatePicker, setOpenDatePicker] = useState(false);

//   // const handleDateChange = (date) => {
//   //   setSelectedDate(date);
//   // };
//   const handleSearch = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   const filteredsundayData = sundayData.filter((item) =>
//     //item.EmpName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     item.serviceNo.toString().includes(searchTerm)
//   );

//   // Handle job change
//   const handleJobChange = (event) => {
//     const selectedJob = event.target.value;
//     const selectedJobData = jobValue.find(
//       (job) => job.jobDescription === selectedJob
//     );
//     if (selectedJobData) {
//       setSelectedJob(selectedJob);
//       setSelectedJobIwno(selectedJobData.iwNo);
//       // console.log(selectedJobData.iwNo);
//     }
//   };

//   const handleLocationChange = (event) => {
//     const newLocation = event.target.value;
//     setSelectedLocation(newLocation);
//   };

//   const handleJobClick = (iwNo, jobId) => {
//     if (showDropdown === iwNo) {
//       setShowDropdown(null); // Close the dropdown if the same job is clicked again
//     } else {
//       setShowDropdown(iwNo); // Open the dropdown for the selected job
//       const date = getTodayDate();
//       dispatch(fetchOTjobAttendance(date, department, selectedLocation, iwNo));
//     }
//   };

//   const getTodayDate = () => new Date().toISOString().split("T")[0];

//   // Fetch data on component mount
//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchOTtimes());
//       dispatch(fetchLocations(department));
//       dispatch(fetchSundayData(selectedLocation)); // Fetch Sunday-specific data
//     }
//   }, [dispatch, role, department, employeeId, selectedLocation]);

//   // Filter time slots based on selected type
//   useEffect(() => {
//     const filteredSlots = timeSlots.filter(
//       (slot) => slot.Type === selectedType
//     );
//     setFilteredTimeSlots(filteredSlots);
//     setSelectedTimes("");
//   }, [selectedType, timeSlots]);

//   // Handle type change

//   // Handle time change
//   const handleTimeChange = (event) => {
//     const selectedTimes = event.target.value;
//     const selectedTimesData = filteredTimeSlots.find(
//       (slot) =>
//         `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//           slot.OutTime
//         )}` === selectedTimes
//     );
//     if (selectedTimesData) {
//       setSelectedTimes(selectedTimes);
//       setSelectedTimeId(selectedTimesData.Id);
//     }
//   };

//   const handleCheckboxChange2 = (serviceNo) => {
//     setSelectedAttendanceSND((prev) => {
//       const updatedState = { ...prev, [serviceNo]: !prev[serviceNo] };
//       return updatedState;
//     });
//   };

//   // Handle form submission
//   const handleSubmit = () => {
//     console.log("Submit button clicked");
//     const selectedEmpData = sundayData.filter(
//       (item) => selectedAttendanceSND[item.serviceNo]
//     );

//     // const dateselected = selectedDate.toISOString().split("T")[0]
//     const formatDate = (date) => {
//       if (!date) return "";
//       const offset = date.getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
//       const localDate = new Date(date.getTime() - offset); // Adjust for timezone
//       return localDate.toISOString().split("T")[0]; // Format to yyyy-mm-dd
//     };

//     const dateselected = formatDate(selectedDate);
//     console.log(dateselected);

//     if (
//       !selectedJob ||
//       !selectedTimes ||
//       !selectedType ||
//       selectedEmpData.length === 0
//     ) {
//       setSnackbarMessage(
//         "Please select a type, job, time slot, and at least one employee."
//       );
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }
//     const atttendOtList = selectedEmpData.map((item) => ({
//       serviceNo: item.serviceNo,
//       iwNo: selectedJobIwno,
//       date: dateselected,
//       Otid: selectedTimeId,
//       CreatedBy: employeeId,
//       location: role,
//       Emp_Location: selectedLocation,
//     }));

//     const postData = {
//       atttendOTList: JSON.stringify(atttendOtList),
//       supervisor: employeeId,
//     };

//     console.log(postData);

//     setIsSubmitAttempted(true);
//     dispatch(assignOT(postData));
//     setSelectedType("SND");
//     setSelectedTimes("");
//     setSelectedLocation(role);
//     setSelectedAttendanceSND({});
//   };

//   // Snackbar for success/error messages
//   useEffect(() => {
//     if (isSubmitAttempted && otAssignLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//       } else {
//         setSnackbarMessage("Overtime assigned successfully!");
//         setSnackbarSeverity("success");
//       }
//       setSnackbarOpen(true);
//       setIsSubmitAttempted(false);
//     }
//   }, [otAssignLoading, error, isSubmitAttempted]);

//   // Helper functions

//   const formatTimeTo12Hour = (time) => {
//     const [hours, minutes] = time.split(":");
//     const date = new Date();
//     date.setHours(parseInt(hours, 10));
//     date.setMinutes(parseInt(minutes, 10));
//     return date.toLocaleTimeString("en-US", {
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   // Dropdown options
//   const dropdownOptions = {
//     typeOptions: [
//       { value: "HSD", label: "Company Holidays and Sunday" },
//       { value: "SD", label: "Saturday" },
//       { value: "SND", label: "Sunday" },
//       { value: "WD", label: "Weekdays" },
//     ],
//     timeSlotOptions: filteredTimeSlots.map((slot) => ({
//       value: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//       label: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
//         slot.OutTime
//       )}`,
//     })),
//     locationOptions: locationValue?.map((location) => ({
//       value: location.location,
//       label: location.locationDescription,
//     })),
//   };

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//   {/* Search Field */}
//   <Grid item xs={12} sm={4}>
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//       <TextField
//         label="Search by Service Number"
//         variant="outlined"
//         fullWidth
//         value={searchTerm}
//         onChange={handleSearch}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon sx={{ color: "#154C79" }} />
//             </InputAdornment>
//           ),
//         }}
//         sx={{
//           fontSize: { xs: "0.85rem", sm: "1rem" },
//           color: "#154C79",
//           borderRadius: "20px",
//           "& .MuiOutlinedInput-root": {
//             borderRadius: "20px",
//           },
//           "& .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#154C79",
//           },
//         }}
//       />
//     </Box>
//   </Grid>

//   {/* Date Picker & Time Slots in Same Row with Equal Size */}
//   <Grid item xs={12} sm={4}>
//     <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
//       {/* Date Picker Button */}
//       <Button
//         variant="contained"
//         onClick={() => setOpenDatePicker(true)}
//         sx={{
//           flexGrow: 1,
//           borderRadius: "25px",
//           padding: "7px 70px",
//           backgroundColor: "#142c54",
//           color: "#fff",
//           fontWeight: "bold",
//           textTransform: "none",
//           "&:hover": { backgroundColor: "#0D47A1" },
//         }}
//       >
//         <CalendarTodayIcon sx={{ marginRight: "8px" }} />
//         Date
//       </Button>

//       {/* Date Picker Modal */}
//       <LocalizationProvider dateAdapter={AdapterDateFns}>
//         {openDatePicker && (
//           <DatePicker
//             label="Select Date"
//             value={selectedDate}
//             onChange={(newValue) => {
//               setSelectedDate(newValue);
//               setOpenDatePicker(false);
//             }}
//             renderInput={(params) => <TextField {...params} fullWidth />}
//             open={openDatePicker}
//             onClose={() => setOpenDatePicker(false)}
//           />
//         )}
//       </LocalizationProvider>

//       {/* Time Slot Dropdown */}
//       <Dropdown
//         label="Time Slots"
//         value={selectedTimes}
//         onChange={handleTimeChange}
//         options={dropdownOptions.timeSlotOptions}
//         loading={timeSlotLoading}
//         //sx={{ flexGrow: 1 }}
//          sx={{flexGrow: 1,
//                       whiteSpace: "normal", // Ensures long text wraps within the dropdown
//                       wordWrap: "break-word", // Prevents overflow by wrapping long words
//                       padding: "8px 16px", // Adds padding for better spacing
//                       fontWeight: "400", // Adjusts font weight for clarity
//                       fontSize: "14px", // Sets a consistent font size
//                       lineHeight: "1.5", // Ensures good line height for readability
//                       overflow: "hidden", // Prevents overflow issues
//                       textOverflow: "ellipsis", // Adds ellipsis if text is too long
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)", // Adds hover effect for better interactivity
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)", // Changes selected background color
//                       },
//                     }}
//       />
//     </Box>
//   </Grid>

//   {/* Job & Location */}
//   <Grid item xs={12} sm={4}>
//     <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
//       <FormControl fullWidth>
//         <InputLabel sx={{ fontSize: { xs: "0.85rem", sm: "1rem" }, color: "#154C79" }}>
//           Job
//         </InputLabel>
//         <Select
//           value={selectedJob}
//           onChange={handleJobChange}
//           label="Job"
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             borderRadius: "20px",
//             backgroundColor: "#F0F4F8",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "& .MuiSelect-icon": { color: "#154C79" },
//             "& .MuiOutlinedInput-notchedOutline": { borderColor: "#154C79" },
//           }}
//           MenuProps={{
//             PaperProps: { sx: { maxHeight: 250, overflowY: "auto" } },
//           }}
//         >
//           {jobLoading ? (
//             <MenuItem value=""><em>Loading...</em></MenuItem>
//           ) : (
//             jobValue?.map((job, index) => (
//               <MenuItem key={index} value={job.jobDescription} 
//               sx={{
//                       whiteSpace: "normal", // Ensures long text wraps within the dropdown
//                       wordWrap: "break-word", // Prevents overflow by wrapping long words
//                       padding: "8px 16px", // Adds padding for better spacing
//                       fontWeight: "400", // Adjusts font weight for clarity
//                       fontSize: "14px", // Sets a consistent font size
//                       lineHeight: "1.5", // Ensures good line height for readability
//                       overflow: "hidden", // Prevents overflow issues
//                       textOverflow: "ellipsis", // Adds ellipsis if text is too long
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)", // Adds hover effect for better interactivity
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)", // Changes selected background color
//                       },
//                     }}>
//                 {job.jobDescription}
//               </MenuItem>
//             ))
//           )}
//         </Select>
//       </FormControl>

//       {/* Location Dropdown */}
//       <Dropdown
//         label="Location"
//         value={selectedLocation}
//         onChange={handleLocationChange}
//         options={dropdownOptions.locationOptions}
//         loading={locationLoading}
//         sx={{ flexGrow: 1 }}
//       />
//     </Box>
//   </Grid>
// </Grid>


//       <Box sx={{ maxHeight: "400px", overflowY: "auto", marginTop: "30px" }}>
//         {sundayDataLoading ? (
//           <Box>
//             {/* {[...Array(5)].map((_, index) => ( */}
//             <Box
//               // key={index}
//               sx={{
//                 padding: "10px",
//                 borderRadius: "10px",
//                 marginBottom: "12px",
//                 boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                 backgroundColor: "#ffffff",
//                 border: "1px solid #ddd",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "15px",
//               }}
//             >
//               <Skeleton variant="circular" width={60} height={60} />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   flexGrow: 1,
//                 }}
//               >
//                 <Skeleton variant="text" width="80%" height={20} />
//                 <Skeleton variant="text" width="50%" height={16} />
//               </Box>
//               <Skeleton variant="rectangular" width={24} height={24} />
//             </Box>
//             {/* ))} */}
//           </Box>
//         ) : filteredsundayData && filteredsundayData.length > 0 ? (
//           filteredsundayData.map((item) => (
//             <Box
//               key={item.serviceNo}
//               sx={{
//                 padding: "10px",
//                 borderRadius: "10px",
//                 marginBottom: "12px",
//                 boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                 backgroundColor: "#ffffff",
//                 border: "1px solid #ddd",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "15px",
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
//                 <img
//                   src={`https://esystems.cdl.lk/backend-test/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//                   alt={item.EmpName}
//                   style={{
//                     width: "60px",
//                     height: "60px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #154C79",
//                   }}
//                   onError={(e) => {
//                     const firstLetter = item.EmpName
//                       ? item.EmpName.charAt(0).toUpperCase()
//                       : "U";
//                     e.target.src = `https://dummyimage.com/60x60/ddd/000.png&text=${firstLetter}`;
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontSize: "16px",
//                       fontWeight: "600",
//                       color: "#154C79",
//                     }}
//                   >
//                     {item.empName}
//                   </Typography>
//                   <Typography sx={{ fontSize: "14px", color: "#6C757D" }}>
//                     Service No: {item.serviceNo}
//                   </Typography>
//                 </Box>
//               </Box>
//               {/* <Checkbox /> */}

//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={!!selectedAttendanceSND[item.serviceNo]} // Ensure correct checked state
//                     onChange={(event) => {
//                       handleCheckboxChange2(item.serviceNo); // Call the same function
//                       console.log("tyu:", selectedAttendanceSND);
//                     }}
//                     sx={{ marginLeft: 2 }}
//                   />
//                 }
//                 //onClick={(event) => event.stopPropagation()} // Prevent parent click
//                 label=""
//               />
//             </Box>
//           ))
//         ) : (
//           <Typography
//             variant="body1"
//             sx={{ textAlign: "center", padding: "20px" }}
//           >
//             No Sunday data available.
//           </Typography>
//         )}
//       </Box>

//       <Box textAlign="center" sx={{ marginTop: 1 }}>
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           sx={{
//             backgroundColor: "#142c54",
//             marginRight: 2,
//             "&:hover": {
//               backgroundColor: "#0f2241",
//             },
//           }}
//         >
//           Assign
//         </Button>
//       </Box>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default HolidayOT;




import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Checkbox,
  FormControlLabel,
  Button,
  TextField,
  Snackbar,
  Alert,
  Select,
  Skeleton,
  InputAdornment,
} from "@mui/material";
import HeaderBannerPage from "../components/HeaderBannerPage";
import SearchIcon from "@mui/icons-material/Search";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import {  fetchOTtimes,  assignOT,  fetchOTjobAttendance,  fetchSundayData,  fetchHolidays} from "../actions/OTAction";
import { fetchLocations, fetchJobs } from "../actions/AssignAction";
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
import { useLocation } from "react-router-dom";import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { maxWidth } from "@mui/system";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { isSameDay } from "date-fns";


const Dropdown = ({ label, value, onChange, options, loading }) => (
  
  <FormControl fullWidth>
    <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
      {label}
    </InputLabel>
    <Select
      value={value}
      onChange={onChange}
      label={label}
      sx={{
        fontSize: { xs: "0.85rem", sm: "1rem" },
        borderRadius: "20px",
        backgroundColor: "#F0F4F8",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        "& .MuiSelect-icon": {
          color: "#154C79",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#154C79",
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 200,
            overflowY: "auto",
          },
        },
      }}
    >
      {loading ? (
        <MenuItem value="">Loading...</MenuItem>
      ) : options.length ? (
        options.map((option, index) => (
          <MenuItem
            key={index}
            value={option.value}
            sx={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              padding: "7px 16px",
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "1.5",
              overflow: "hidden",
              textOverflow: "ellipsis",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
              },
            }}
          >
            {option.label}
          </MenuItem>
        ))
      ) : (
        <MenuItem value="">No options available</MenuItem>
      )}
    </Select>
  </FormControl>
);



const HolidayOT = () => {
  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().split(" ")[0];
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const { employeeId, department, role } = location.state || {};

  // Redux state selectors
  const { attendanceItems, loading } = useSelector(
    (state) => state.otjobAttendance
  );
  const { timeSlots, loading: timeSlotLoading } = useSelector(
    (state) => state.timeSlots || {}
  );
  const { locationValue, loading: locationLoading } = useSelector(
    (state) => state.assignLocation || {}
  );
  const { loading: otAssignLoading, error } = useSelector(
    (state) => state.assignOTpost || {}
  );
  const { sundayData, loading: sundayDataLoading } = useSelector(
    (state) => state.sundayData
  );

  const holidays = useSelector((state) => state.holidays.holidays || []);
 
  
  const { jobValue, loading: jobLoading } = useSelector(
    (state) => state.assignJob || {}
  );
  // Local state
  const [selectedTimes, setSelectedTimes] = useState("");
  const [selectedTimeId, setSelectedTimeId] = useState("");
  const [selectedType, setSelectedType] = useState("SND");//SND
  const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
  const [selectedAttendanceSND, setSelectedAttendanceSND] = useState({});
  const [selectedJob, setSelectedJob] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedLocation, setSelectedLocation] = useState(role);
  const [showDropdown, setShowDropdown] = useState(null);
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
  const [selectedJobIwno, setSelectedJobIwno] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [showDates, setShowDates] = useState(false);

  
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredsundayData = sundayData.filter((item) =>
     
    item.serviceNo.toString().includes(searchTerm)
  );


  const handleLocationChange = (event) => {
    const newLocation = event.target.value;
    setSelectedLocation(newLocation);
  };
 

  const getTodayDate = () => new Date().toISOString().split("T")[0];

  // Fetch data on component mount
  useEffect(() => {
    if (employeeId && department) {
      const date = getTodayDate();
      // dispatch(fetchJobs(date, employeeId));
      dispatch(fetchOTtimes());
      dispatch(fetchLocations(department));
      dispatch(fetchSundayData(selectedLocation)); // Fetch Sunday-specific data
      dispatch(fetchHolidays());
    }
  }, [dispatch, role, department, employeeId, selectedLocation]);

  // Filter time slots based on selected type
  useEffect(() => {
    const filteredSlots = timeSlots.filter(
      (slot) => slot.Type === selectedType
    );
    setFilteredTimeSlots(filteredSlots);
    setSelectedTimes("");
  }, [selectedType, timeSlots]);



  // Handle time change
  const handleTimeChange = (event) => {
    const selectedTimes = event.target.value;
    const selectedTimesData = filteredTimeSlots.find(
      (slot) =>
        `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
          slot.OutTime
        )}` === selectedTimes
    );
    if (selectedTimesData) {
      setSelectedTimes(selectedTimes);
      setSelectedTimeId(selectedTimesData.Id);
    }
  };

  const handleCheckboxChange2 = (serviceNo) => {
    setSelectedAttendanceSND((prev) => {
      const updatedState = { ...prev, [serviceNo]: !prev[serviceNo] };
      return updatedState;
    });
  };

  // Handle form submission
  const handleSubmit = () => {
    console.log("Submit button clicked");
    const selectedEmpData = sundayData.filter(
      (item) => selectedAttendanceSND[item.serviceNo] 
    );
  
    const formatDate = (date) => {
      if (!date) return "";
      const offset = date.getTimezoneOffset() * 60000;
      const localDate = new Date(date.getTime() - offset);
      return localDate.toISOString().split("T")[0];
    };
  
    const dateselected = formatDate(selectedDate);         

   if ( !selectedTimes || !selectedType || selectedEmpData.length === 0 ) 
      {
      setSnackbarMessage(
        "Please select a type, time slot, and at least one valid employee."
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
      ///Holiday ot /////
      const formatDateToYMD_LK = (dateStr) => {
      const date = new Date(dateStr);
      // Adjust for Sri Lanka timezone (UTC+5:30)
      const offsetInMinutes = 330;
      const localDate = new Date(date.getTime() + offsetInMinutes * 60000);

      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, '0');
      const day = String(localDate.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    };
    
      const isHoliday = holidays.some((holidays) => {
      const formattedHolidayDate = formatDateToYMD_LK(holidays.Cdate);
      //console.log("Comparing:", formattedHolidayDate, "with selected:", dateselected);
      return formattedHolidayDate === dateselected;
      });


        if (!isHoliday) {
        setSnackbarMessage("Selected date is not a holiday. Cannot assign OT.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
        }     
  
    const atttendOtList = selectedEmpData.map((item) => ({
      serviceNo: item.serviceNo,
      iwNo: item.iwNo ?? 0,
      date: `${dateselected} ${getCurrentTime()}`,
      Otid: selectedTimeId,
      CreatedBy: employeeId,
      location: role,
      Emp_Location: selectedLocation,
      HolidayOT_Status: "Y"
    }));
  
    const postData = {
      atttendOTList: JSON.stringify(atttendOtList),
      supervisor: employeeId,
    };
  

  
    setIsSubmitAttempted(true);
    dispatch(assignOT(postData));
    setSelectedType("SND");
    setSelectedTimes("");
    setSelectedLocation(role);
    setSelectedAttendanceSND({});
    setSelectedDate(new Date());
  };
  

  // Snackbar for success/error messages
  useEffect(() => {
    if (isSubmitAttempted && otAssignLoading === false) {
      if (error) {
        setSnackbarMessage(`Error: ${error.message}`);
        setSnackbarSeverity("error");
      } else {
        setSnackbarMessage("Overtime assigned successfully!");
        setSnackbarSeverity("success");
      }
      setSnackbarOpen(true);
      setIsSubmitAttempted(false);
    }
  }, [otAssignLoading, error, isSubmitAttempted]);

  // Helper functions

  const formatTimeTo12Hour = (time) => {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Dropdown options
  const dropdownOptions = {
    typeOptions: [
      { value: "HSD", label: "Company Holidays and Sunday" },
      { value: "SD", label: "Saturday" },
      { value: "SND", label: "Sunday" },
      { value: "WD", label: "Weekdays" },
    ],
    timeSlotOptions: filteredTimeSlots.map((slot) => ({
      value: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
        slot.OutTime
      )}`,
      label: `${formatTimeTo12Hour(slot.Intime)} - ${formatTimeTo12Hour(
        slot.OutTime
      )}`,
    })),
    locationOptions: locationValue?.map((location) => ({
      value: location.location,
      label: location.locationDescription,
    })),
  };


  
  

   

  return (
    <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
      <HeaderBannerPage />
      <Grid container spacing={2} sx={{ marginBottom: 3 }}>
  {/* Search Field */}
  <Grid item xs={12} sm={4}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <TextField
        label="Search by Service Number"
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#154C79" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          fontSize: { xs: "0.85rem", sm: "1rem" },
          color: "#154C79",
          borderRadius: "20px",
          "& .MuiOutlinedInput-root": {
            borderRadius: "20px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#154C79",
          },
        }}
      />
    </Box>
  </Grid>

  {/* Date Picker & Time Slots in Same Row with Equal Size */}
  <Grid item xs={12} sm={4}>
    <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
      {/* Date Picker Button */}      

      <Button
        variant="contained"
        onClick={() => setOpenDatePicker(true)}
        sx={{
          flexGrow: 1,
          borderRadius: "25px",
          padding: "7px 70px",
          backgroundColor: "#142c54",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "none",
          "&:hover": { backgroundColor: "#0D47A1" },
        }}
      >
        <CalendarTodayIcon sx={{ marginRight: "8px" }} />
        
        {selectedDate ? format(selectedDate, "dd/MM/yyyy") : "Pick a Date"}
      </Button>      
                 

     
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {openDatePicker && (
          <DatePicker
            label="Select Date"
            value={selectedDate}
            onChange={(newValue) => {
              setSelectedDate(newValue);
              setOpenDatePicker(false);
            }}
            renderInput={(params) => <TextField {...params} fullWidth />}
            open={openDatePicker}
            onClose={() => setOpenDatePicker(false)}
          />
        )}
      </LocalizationProvider>

      


 {/* /////////////// testt */}
 
   









      {/* Time Slot Dropdown */}
      <Dropdown
        label="Time Slots"
        value={selectedTimes}
        onChange={handleTimeChange}
        options={dropdownOptions.timeSlotOptions}
        loading={timeSlotLoading}
        //sx={{ flexGrow: 1 }}
         sx={{flexGrow: 1,
                      whiteSpace: "normal", // Ensures long text wraps within the dropdown
                      wordWrap: "break-word", // Prevents overflow by wrapping long words
                      padding: "8px 16px", // Adds padding for better spacing
                      fontWeight: "400", // Adjusts font weight for clarity
                      fontSize: "14px", // Sets a consistent font size
                      lineHeight: "1.5", // Ensures good line height for readability
                      overflow: "hidden", // Prevents overflow issues
                      textOverflow: "ellipsis", // Adds ellipsis if text is too long
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.08)", // Adds hover effect for better interactivity
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 0, 0, 0.12)", // Changes selected background color
                      },
                    }}
      />
    </Box>
  </Grid>

  {/* Job & Location */}
  <Grid item xs={12} sm={4}>
    <Box sx={{ display: "flex", gap: 2, width: "100%" }}>

      
      
      <Dropdown
        label="Location"
        value={selectedLocation}
        onChange={handleLocationChange}
        options={dropdownOptions.locationOptions}
        loading={locationLoading}
        sx={{ flexGrow: 1 }}
      />
    </Box>
  </Grid>
</Grid>


      <Box sx={{ maxHeight: "400px", overflowY: "auto", marginTop: "30px" }}>
        {sundayDataLoading ? (
          <Box>
            {[...Array(5)].map((_, index) => (
            <Box
              // key={index}
              sx={{
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "12px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#ffffff",
                border: "1px solid #ddd",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "15px",
              }}
            >
              <Skeleton variant="circular" width={60} height={60} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                }}
              >
                <Skeleton variant="text" width="80%" height={20} />
                <Skeleton variant="text" width="50%" height={16} />
              </Box>
              <Skeleton variant="rectangular" width={24} height={24} />
            </Box>
            ))}
          </Box>
        ) : filteredsundayData && filteredsundayData.length > 0 ? (
          filteredsundayData.map((item) => (
            <Box
              key={item.serviceNo}
              sx={{
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "12px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#ffffff",
                border: "1px solid #ddd",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "15px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
                <img
                  src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
                  alt={item.EmpName}
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #154C79",
                  }}
                  onError={(e) => {
                    const firstLetter = item.EmpName
                      ? item.EmpName.charAt(0).toUpperCase()
                      : "U";
                    e.target.src = `https://dummyimage.com/60x60/ddd/000.png&text=${firstLetter}`;
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#154C79",
                    }}
                  >
                    {item.empName}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: "#6C757D" }}>
                    Service No: {item.serviceNo}
                  </Typography>
                </Box>
              </Box>
              {/* <Checkbox /> */}

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!selectedAttendanceSND[item.serviceNo]} // Ensure correct checked state
                    onChange={(event) => {
                      handleCheckboxChange2(item.serviceNo); // Call the same function
                      console.log("tyu:", selectedAttendanceSND);
                    }}
                    sx={{ marginLeft: 2 }}
                  />
                }
                //onClick={(event) => event.stopPropagation()} // Prevent parent click
                label=""
              />
            </Box>
          ))
        ) : (
          <Typography
            variant="body1"
            sx={{ textAlign: "center", padding: "20px" }}
          >
            No Sunday data available.
          </Typography>
        )}
      </Box>

      <Box textAlign="center" sx={{ marginTop: 1 }}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            backgroundColor: "#142c54",
            marginRight: 2,
            "&:hover": {
              backgroundColor: "#0f2241",
            },
          }}
        >
          Assign
        </Button>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default HolidayOT;
